import { Icon } from "@material-ui/core";
import Button from "Components/Common/Button/Button";
import Toolbar from "Components/Common/Toolbar/Toolbar";
import ContentView from "Components/ContentView/ContentView";
import RouterLink from "Components/RouterLink/RouterLink";
import { RouterLinkType } from "Enums/RouterLinkType";
import { AuditTemplate } from "Models/Audit/AuditTemplate";
import { DataState } from "Models/Common/DataState";
import * as React from "react";
import { connect } from "react-redux";
import { IAuditTemplateState } from "Store/AuditTemplates/AuditTemplateState";
import { IApplicationState } from "Store/Store";
import i18n from "Translations/i18n";
import styles from "./AuditTemplateDetailHeader.scss";

const mapStateToProps = (state: IApplicationState) => ({
    auditTemplateState: state.auditTemplateState
});

interface IProps {
    auditTemplateState: IAuditTemplateState;
    auditTemplate: AuditTemplate;
    isDuplicating: boolean;
    canDuplicate: boolean;
    duplicate: () => void;
    onAuditDeletedClicked(): void;
    save: () => void;
    saveAndAddAnother: () => void;
}

interface IState {
    isSaving: boolean;
    canDuplicate: boolean;
    isDuplicating: boolean;
    isDeleting: boolean;
    createNewAfterSave: boolean;
}
export class AuditTemplateDetailHeader extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            isSaving: false,
            canDuplicate: props.canDuplicate,
            isDuplicating: props.isDuplicating,
            isDeleting: false,
            createNewAfterSave: false
        };

        this.save = this.save.bind(this);
        this.saveAndAddAnother = this.saveAndAddAnother.bind(this);
        this.duplicate = this.duplicate.bind(this);
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const partialState: Partial<IState> = {};

        if (nextProps.auditTemplateState.detailAuditTemplateStates &&
            (nextProps.auditTemplateState.detailAuditTemplateStates[nextProps.auditTemplate.id || -1] === DataState.Saving) !== prevState.isSaving) {
            partialState.isSaving = nextProps.auditTemplateState.detailAuditTemplateStates[nextProps.auditTemplate.id || -1] === DataState.Saving;
            if (!partialState.isSaving) {
                partialState.isDuplicating = false;
            }
        }
        else if (nextProps.auditTemplateState.detailAuditTemplateStates &&
            (nextProps.auditTemplateState.detailAuditTemplateStates[nextProps.auditTemplate.id || -1] === DataState.Deleting) !== prevState.isDeleting) {
            partialState.isDeleting = nextProps.auditTemplateState.detailAuditTemplateStates[nextProps.auditTemplate.id || -1] === DataState.Deleting;
        }
        
        if (nextProps.isDuplicating !== prevState.isDuplicating) {
            partialState.isDuplicating = nextProps.isDuplicating;
        }

        if (nextProps.canDuplicate !== prevState.canDuplicate) {
            partialState.canDuplicate = nextProps.canDuplicate;
        }

        return partialState;
    }

    public save() {
        this.setState({ createNewAfterSave: false });
        this.props.save();
    }

    public saveAndAddAnother() {
        this.setState({ createNewAfterSave: true });
        this.props.saveAndAddAnother();
    }

    public duplicate() {
        this.setState({ isDuplicating: true });
        this.props.duplicate();
    }

    public render() {
        return (
            <ContentView className={styles.auditTemplateDetailHeader}>
                <Toolbar>
                <Button id="btnDuplicate" onClick={this.duplicate} isLoading={this.state.isDuplicating} disabled={!this.state.canDuplicate || this.state.isSaving || this.state.isDeleting || this.state.isDuplicating || !this.props.auditTemplate.id}>
                        <Icon>file_copy</Icon>
                        {i18n.t("common.duplicate")}
                    </Button>
                    <Button id="btnDelete" onClick={this.props.onAuditDeletedClicked} isLoading={this.state.isDeleting} disabled={this.state.isSaving || this.state.isDeleting || this.state.isDuplicating || !this.props.auditTemplate.id}>
                        <Icon>delete</Icon>
                        {i18n.t("common.delete")}
                    </Button>
                    <Button id="btnSave" onClick={this.save} isLoading={this.state.isSaving && !this.state.createNewAfterSave} disabled={this.state.isSaving || this.state.isDeleting || this.state.isDuplicating}>
                        <Icon>check</Icon>
                        {i18n.t("common.save")}
                    </Button>
                    <Button id="btnSaveAndAddAnother" onClick={this.saveAndAddAnother} isLoading={this.state.isSaving && this.state.createNewAfterSave} disabled={this.state.isSaving || this.state.isDeleting || this.state.isDuplicating}>
                        <Icon>check</Icon>
                        {i18n.t("common.saveAndAddAnother")}
                    </Button>
                </Toolbar>
                <RouterLink type={RouterLinkType.default} to="/audittemplates" className={styles.backToOverview}>
                    <Icon className={styles.icon}>arrow_back</Icon>
                    {i18n.t("audits.backToOverview")}
                </RouterLink>
                <h1>{i18n.t("audits.detailsTitle")}</h1>
            </ContentView>
        );
    }
}

export default connect(mapStateToProps)(AuditTemplateDetailHeader);


// WEBPACK FOOTER //
// ./src/Components/Pages/AuditTemplateDetailView/AuditTemplateDetailHeader/AuditTemplateDetailHeader.tsx